import { mapStyles } from './mapStyles';

export const mapSettings = {
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  zoomControl: false,
  disableDefaultUI: true,
  zoom: 12,
  minZoom: 5,
  styles: mapStyles,
};

const baseUrl = (window as never)['baseUrl'];

export const customMapSettings = {
  markerIconUrl: `${baseUrl}/img/icon-marker.png`,
  markerIconSize: 40,
};

export function hasLabelsEnabled(mapId: string) {
  return mapId === 'e4c94b62edb641a0';
}

export function getMapId(isLabelsEnabled: boolean) {
  return isLabelsEnabled ? 'e4c94b62edb641a0' : 'd9466559ed301c74';
}
